import * as React from 'react';
import { memo } from 'react';

import { SelectOption, SilentSelectField, breakpoints, useMediaQuery } from '@coursera/cds-core';

import withSingleTracked from 'bundles/common/components/withSingleTracked';
import type { SearchSortType } from 'bundles/search-common/types';

import _t from 'i18n!nls/search-common';

const TrackedSilentSelectField = withSingleTracked({ type: 'CHECKBOX' })(SilentSelectField);

type Props = {
  shouldHide?: boolean;
  changeIndex?: (indexName: SearchSortType) => void;
  sortByValue?: string;
  hideLabelOnMobile?: boolean;
};

export const SortByIndex: React.FC<Props> = ({ changeIndex, sortByValue, shouldHide, hideLabelOnMobile }) => {
  const clickSortByOption = (value: SearchSortType) => {
    if (changeIndex) changeIndex(value);
  };
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  if (shouldHide) {
    return null;
  }
  return (
    <TrackedSilentSelectField
      defaultValue="BEST_MATCH"
      value={sortByValue}
      trackingName="search_index"
      label={_t('Sort by')}
      labelPlacement={hideLabelOnMobile && isMobile ? 'none' : 'integrated'}
      onChange={(e) => clickSortByOption(e.target.value as SearchSortType)}
    >
      <SelectOption value="BEST_MATCH">{_t('Best Match')}</SelectOption>
      <SelectOption value="NEW">{_t('Newest')}</SelectOption>
    </TrackedSilentSelectField>
  );
};
export default memo(SortByIndex);
